module.exports = __webpack_public_path__ + "static/media/25.86bfbf19.JPG";